import React, { useMemo, useState } from "react";
import AddItm from '../addItm/AddItm.js';
import SearchInput from '../searchInput/SearchInput.js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash, faFileLines } from "@fortawesome/free-solid-svg-icons";

import Swal from 'sweetalert2';

import { checkDoubleQuotes, removeDoubleQuotesFromFilter } from "../../utils/funciones.js";
import normalizeText from "../../utils/normalizeText.js";

import './TemplatesProduccionList.css';

const TemplatesProduccionList = ({ templatesList, setTemplateToEdit, setShowABM, eliminarTemplateProduccion, actualizarTemplatesProduccionList }) => {

    const [filter, setFilter] = useState('');

    const handleClickAdd = () => {
        setTemplateToEdit({});
        setShowABM(false);
    };

    const handleSearchInput = (e) => {
        setFilter(e);
    };

    const handleClickModify = (template) => {
        setTemplateToEdit(template);
        setShowABM(false);
    };

    const handleClickDelete = async (template) => {
        Swal.fire({
            title: `Esta seguro que desea eliminar el template ${template.codTemplate}?`,
            showDenyButton: true,
            confirmButtonText: 'Si, estoy seguro',
            confirmButtonColor: '#ff0000',
            denyButtonColor: '#3d4d87',
            denyButtonText: 'No',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const res = await eliminarTemplateProduccion(template._id);
                if (res?.deleted) {
                    Swal.fire({
                        title: res.message,
                        icon: 'success',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarTemplatesProduccionList();
                } else {
                    Swal.fire({
                        title: 'No se pudo eliminar el template',
                        icon: 'error',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            }
        });
    };

    const templatesFiltered = useMemo(() => templatesList?.filter(t => {
        return filter !== ''
            ? checkDoubleQuotes(filter)
                ? normalizeText(t.codTemplate) === removeDoubleQuotesFromFilter(filter) || normalizeText(t.name) === removeDoubleQuotesFromFilter(filter)
                : normalizeText(t.codTemplate).includes(normalizeText(filter)) || normalizeText(t.name).includes(normalizeText(filter))
            : true;
    }), [templatesList, filter]);

    if (templatesList == null) {
        return <h3 className="warningStatusMsg">Cargando <span>.</span><span>.</span><span>.</span></h3>;
    }

    return (
        <div className="templatesProduccionList">
            <AddItm titulo={'Template'} anadiritm={handleClickAdd} />
            <SearchInput buscar={handleSearchInput} filter={filter} />
            {templatesFiltered.length === 0
                ? <h3 className="warningStatusMsg">No hay templates cargados</h3>
                : templatesFiltered.map((t, i) => (
                    <div key={t._id} className="templateRow">
                        <div className="infoContainer">
                            <FontAwesomeIcon icon={faFileLines} className="rrIcon" id="primaryIcon" />
                            <div className="infoDiv">
                                <h6>Codigo Template:</h6>
                                <label id="codTemplateLabel">{t.codTemplate}</label>
                            </div>
                            <div className="infoDiv">
                                <h6>Nombre Template:</h6>
                                <label>{t.name}</label>
                            </div>
                        </div>
                        <div className="funcionesDiv">
                            <FontAwesomeIcon icon={faPenToSquare} onClick={() => handleClickModify(t)} className="rrIcon" />
                            <FontAwesomeIcon icon={faTrash} className="rrIcon" onClick={() => handleClickDelete(t)} />
                        </div>
                    </div>
                ))
            }
        </div>
    );
};

export default TemplatesProduccionList;
